import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getProjects} from '../actions/MainAction';
export class ProjectsPage extends Component {
  
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        num_1: data?.num_1?data?.num_1:"",
        num_2: data?.num_2?data?.num_2:"",
        num_3: data?.num_3?data?.num_3:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            text:lang?.text?lang?.text:'',
            num_1_text:lang?.num_1_text?lang?.num_1_text:'',
            num_2_text:lang?.num_2_text?lang?.num_2_text:'',
            num_3_text:lang?.num_3_text?lang?.num_3_text:'',
            sub_title_1:lang?.sub_title_1?lang?.sub_title_1:'',
            sub_title_2:lang?.sub_title_2?lang?.sub_title_2:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getProjects,
        afterParams:[],
        url:'admin-projects'
      }
    })
  }

  componentDidMount(){
    this.props.getProjects();
  }
  render() {
    const {projectsData} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title="Projects" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            projectsData?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  video={data?.video_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-projects/${data?.id}`}
                  afterCallFunction={()=> this.props.getProjects()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  projectsData: state.Data.projectsData,
});
const mapDispatchToProps = {changeStateValue, getProjects}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectsPage)
 
 
 
